export default "__VITE_ASSET__BHiVUvC$__"